/**
 * Shared module
 */
export * from './shared.module';
